import type { ListPage, WaykeList } from '../@types/List';

export interface ParsedList {
  id: string;
  title: string;
  description: string;
  updatedAt: string;
  createdAt: string;
  image: string | null;
  smallImage: string | null;
  relatedContent: ListPage[] | null;
  slug: string;
  queryFilter: string;
}

class List {
  static parse = ({
    id,
    title,
    description,
    updatedAt,
    createdAt,
    featuredImage,
    cardImage,
    relatedContent,
    slug,
    queryFilter,
  }: WaykeList): ParsedList => {
    const _featuredImage = featuredImage && featuredImage.file ? featuredImage.file.url : null;

    const _cardImage = cardImage && cardImage.file ? cardImage.file.url : null;

    return {
      id,
      title,
      description,
      updatedAt,
      createdAt,
      image: _featuredImage,
      smallImage: _cardImage,
      relatedContent,
      slug,
      queryFilter,
    };
  };
}

export default List;
